<template>
    <div class="formItem formRange" :class="{'formError' : error}">
        <label v-if="!onlyField">{{ label }}
            <span v-if="subLabel"> ({{ subLabel }})</span>
        </label>
        <v-text-field
                type="number"
                solo
                flat
                hide-details
                class="sr-input"
                label="von"
                placeholder="von"
                :value="localValue.from"
                @input="fromValueChanged($event)"
                @blur="blurFromValue"
                :disabled="loading || readonly"
                :readonly="loading || readonly"
        ></v-text-field>
        <small>&hyphen;</small>
        <v-text-field
                type="number"
                solo
                flat
                hide-details
                class="sr-input"
                label="bis"
                placeholder="bis"
                :value="localValue.to"
                @input="toValueChanged($event)"
                @blur="blurToValue"
                :disabled="loading || readonly"
                :readonly="loading || readonly"
        ></v-text-field>
        <small class="unit" v-if="suffix">{{suffix}}</small>
    </div>
</template>

<script>
  export default {
    props: {
      suffix: {
        type: String,
        default: ''
      },
      onlyField: {
        type: Boolean,
        default: false
      },
      error: {
        type: Boolean,
        default: false
      },
      loading: {
        type: Boolean,
        default: false
      },
      readonly: {
        type: Boolean,
        default: false
      },
      label: {
        type: String,
        default: ''
      },
      subLabel: {
        type: String,
        default: ''
      },
      value: {
        type: Object,
        default: null
      }
    },
    methods: {
      blurFromValue () {
        this.$emit('input', {
          from: this.localValue.from,
          to: this.localValue.from > this.localValue.to ? this.localValue.from : this.localValue.to
        })
      },
      blurToValue () {
        this.$emit('input', {
          from: this.localValue.to < this.localValue.from ? this.localValue.to : this.localValue.from,
          to: this.localValue.to
        })
      },
      fromValueChanged (newVal) {
        this.$emit('input', {
          from: parseInt(newVal),
          to: this.localValue.to
        })
      },
      toValueChanged (newVal) {
        this.$emit('input', {
          from: this.localValue.from,
          to: parseInt(newVal)
        })
      }
    },
    computed: {
      localValue: {
        get () {
          if (typeof this.value === 'object' && this.value !== null) {
            return this.value
          }

          return {
            from: null,
            to: null
          }
        },
        set () {
          // do nothing
        }
      }
    }
  }
</script>

<style scoped>

</style>
